export const styles = {
  cardActionStyleSmall: {
    zIndex: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  headerForm: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1em 0',
    flexWrap: 'wrap'
  },
  headerDateTimeBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  headerTitle: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconHeader:{width: '2.6rem', height: '2.6em'},
  customerBoxButton: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20
  },
  contentBox: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  contentField: {
    padding: 10,
    flex: 1,
  },
  contentTotal: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: '1em 0',
    flexWrap: 'wrap'
  },
  contentFieldTotal: {
    padding: 10,
    flex: 1,
  },
  contentSubTotal: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '10px 0',
    flexWrap: 'wrap'
  },
  contentSubFieldTotal: {
    
  },
  contentTextRight: {
    alignText: 'right'
  },
  containerSmall: {
    padding: '3em 1em 6em 1em'
  },
  containerMedium: {
    padding: '0em 1em 1em 1em'
  },
};

export const dummyCustomer = [{
  "id":1,
  "first_name":"Wvgen",
  "last_name":"Wong",
  "email":"v@ola.id",
  "phone":"1234",
  "site_id": 1,
  "address": "123",
  "country": "Singapore",
  "province": "Jakarta",
  "city": "Jakarta",
  "zip": "1010",
  "active": true
  },
  {
    "id":12,
    "first_name":"Wvgen 1",
    "last_name":"Wong 1",
    "email":"v@ola.id",
    "phone":"1234123213",
    "site_id": 1,
    "address": "123123232",
    "country": "Singapore",
    "province": "Jakarta",
    "city": "Jakarta",
    "zip": "1010",
    "active": true
  },
  {
    "id":15,
    "first_name":"Customer",
    "last_name":"Two",
    "email":"c2@email.com",
    "phone":"1234",
    "site_id": 1,
    "address": "JL. Maulana Hasanudin Perumahan Simprug Diporis Blok G 7/18",
    "country": "Indonesia",
    "province": "Banten",
    "city": "Kota Tangerang",
    "zip": "15122",
    "active": true
  }];





// WEBPACK FOOTER //
// ./src/orders/styles.js